import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import GridWrapper from "../../../components/controls/GridWrapper";
import { TextInput } from "../../../components/controls/inputs/BaseInput";
import BaseCreator from "../../../components/creators/baseCreator";
import modalStyles from '../../../components/modalWindows/styles/BaseModalWindow.module.scss'
import { useForm } from "../../../system/hooks/useForm";
import { IMarketingEventsDTO } from "../../../libs/coreapi-dto/dirs/marketingEvents";

interface IValidator {
    name: string,
}

const MarketingCompensatedDiscountCreatorModal: FC<ICreatorModalProps<IMarketingEventsDTO>> = (props) => {

    const [marketingEvent, setMarketingEvent] = useState<IMarketingEventsDTO>(props.data ?? {} as IMarketingEventsDTO);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    const { t } = useTranslation();
    const baseT = (value: string) => t('directory.marketing.' + value);
    const errorsT = (value: string) => t('errors.' + value);

    const { isValid, errors, setErrors } = useForm<IValidator>({
        validations: {
            name: {
                required: {
                    value: marketingEvent.name  ? false : true,
                    message: errorsT("required")
                }
            },
        }
    });

    const handleSubmit = () => {
        if (isValid()) {
            props.save({ ...marketingEvent });
            setIsSubmitting(true)
        }
    }


    return (
        <BaseCreator
            variant={props.variant}
            isSubmitting={isSubmitting}
            save={handleSubmit}
            cancel={props.cancel}
            modalWindowClassName={modalStyles.flexModalWindow}
            valid={!props.lockFromPermission}
        >
            <GridWrapper cols={1}>
                <TextInput
                    labelVariant="required"
                    required
                    label={baseT('nameText')} value={marketingEvent.name}
                    onChange={(value) => setMarketingEvent({ ...marketingEvent, name: value })}
                    error={errors.name} onFocus={() => setErrors({ ...errors, name: undefined })} 
                    disabled={props.lockFromPermission}
                />
            </GridWrapper>
            <GridWrapper cols={2}>
                <TextInput
                    label={baseT('StateText')} value={marketingEvent.stateText}
                    onChange={(value) => setMarketingEvent({ ...marketingEvent, stateText: value })}
                    disabled={true}
                />
                <TextInput
                    label={baseT('TypeText')} value={marketingEvent.typeText}
                    onChange={(value) => setMarketingEvent({ ...marketingEvent, typeText: value })} 
                    disabled={props.lockFromPermission}
                />
            </GridWrapper>
        </BaseCreator>
    )
}

export default MarketingCompensatedDiscountCreatorModal